import Layout from 'views/layout/Layout'

export default {
  path: '/brand_service',
  redirect: '/brand_service/list',
  component: Layout,
  name: 'BrandService',
  title: '品牌服务',
  hidden: false,
  icon: 'store',
  permission: ['brand_service'],
  children: [
    {
      path: 'list',
      component: () => import('views/brand_service/Index'),
      name: 'BrandServiceList',
      title: '团购核销',
      keepAlive: true,
      permission: ['brand_service'],
      hidden: false
    },
  ]
}
